import React from "react";
import { useTranslation } from "react-i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import classnames from "classnames";

import { FidelityFormApi } from "../useFidelityForm";

import { HiddenAvGroup, DesignationError } from "./styled";

type Props = {
    form: FidelityFormApi;
    setIsEdited: (v: boolean) => void;
};

export function DesignationField({ form, setIsEdited }: Props) {
    const { t } = useTranslation();
    const { values, errors, setValue, setError } = form;

    return (
        <HiddenAvGroup>
            <StyledLabel className="required__clz mt-3 " htmlFor="name">
                {t("Display name")}
            </StyledLabel>
            <StyledTextInput
                data-testid="fidelity-information-designation-input"
                id="designation"
                name="designation"
                value={values.designation}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setValue("designation", e.target.value.trim());
                    setIsEdited(true);
                    setError("designation", false);
                }}
                className={classnames("not-allowed-icon__clz", {
                    input__clz: errors.designation,
                })}
            />
            {errors.designation ? (
                <DesignationError>
                    {t("Please enter a display name")}
                </DesignationError>
            ) : null}
        </HiddenAvGroup>
    );
}
